module.exports = __webpack_public_path__ + "static/img/intelligent_test_2x.1db488f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rehabitation/intelligent_test_2x.png
// module id = +AsI
// module chunks = 1